import { render } from "./InvalidPage.vue?vue&type=template&id=38e4ca2c"
import script from "./InvalidPage.vue?vue&type=script&lang=js"
export * from "./InvalidPage.vue?vue&type=script&lang=js"
script.render = render

export default script